'use server'

import { redirect } from 'next/navigation'
import { createSession, setSessionCookie } from '@/lib/auth'

const WP_LOGIN = 'https://api.fd2.delivery/wp-json/fd2/v1/login'

export async function loginAction(
  _prevState: { error: string },
  formData: FormData
) {
  const email = (formData.get('email') as string | null)?.trim()
  const password = formData.get('password') as string | null

  if (!email || !password) {
    return { error: 'Correo y contraseña requeridos.' }
  }

  let wp: Response
  let data: Record<string, unknown>
  try {
    wp = await fetch(WP_LOGIN, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    })
    data = await wp.json()
  } catch {
    return { error: 'Error de red. Intenta de nuevo.' }
  }

  if (!wp.ok) {
    return { error: (data.error as string) ?? 'Error al iniciar sesión.' }
  }

  const token = await createSession({
    vendorId:           data.user_id  as number,
    email:              data.email    as string,
    storeName:          data.store_name as string,
    cuisine:            (data.cuisine   as string) ?? '',
    city:               (data.city      as string) ?? '',
    vendorKey:          data.vendor_key as string,
    onboardingComplete: (data.onboarding_complete as boolean) ?? false,
    storeUrl:           (data.store_url  as string) ?? '',
    wcKey:              (data.wc_key     as string) ?? '',
    wcSecret:           (data.wc_secret  as string) ?? '',
  })

  await setSessionCookie(token)
  redirect('/')
}
